/**
 * Created by WangPing on 2019/7/1.
 */
import './index.less'
import Swiper from "../../assets/javascripts/swiper.min";
import '../../assets/styles/swiper.min.css';
import util from "../../assets/javascripts/util";
import interactive from "../../assets/javascripts/interactive";
import {Render, AutoClick, FullScreenClick} from "../../assets/javascripts/common";
import '../../assets/javascripts/windvane.js'

if (module.hot) {
    module.hot.accept()
}
let page = new interactive('RewardJs');

class Main extends Render {
    constructor(bridgeContext) {
        super(bridgeContext);
        this.campaignIdList = [];
        this.videoBridgeContext = {};
        this.imageUrl = ''; //  图片url
        this.screenOrientation = '';    //  屏幕方向
        this.imageWidth = ''; //  图片宽度
        this.imageHeight = '';    //  图片高度
        this.imageBoxLandPer = 0.613;   //  横屏imagebox宽度所占百分比，因为在竖屏转横屏之后不能立刻获取到该元素宽度，所以直接定义
        this.imageBoxPortPer = 1;   //  竖屏imageBox宽度所占百分比，100%
        this.bodyHeight = document.documentElement.clientHeight;// 当前屏幕可视区域高度
        this.bodyWidth = document.documentElement.clientWidth;// 当前屏幕可视区域高度
        this.orientationFlag = false;   //  屏幕方向改变时交换当前屏幕宽高，因为在横屏不能立刻获取到
        this.insertImageCount = 0;  //  向页面中插入图片次数，竖屏一次，横屏一次，最多两次
        this.supportOrientation = typeof window.orientation === 'number';   //  是否支持window.orientation
        this.isFromZip = location.protocol === 'file:'; //  是否来自zip包
        this.fragmentPortrait = document.createDocumentFragment("div"); //  创建竖屏下图片插入的html片段容器
        this.fragmentLandscape = document.createDocumentFragment("div"); //  创建横屏下图片插入的html片段容器
        this.init = this.init.bind(this);
        this.checkScreenOrientation = this.checkScreenOrientation.bind(this);
    }

    // 初始化执行插入页面元素
    init() {
        this.imageUrl = this.campaignInfo.image_url;
        this.initCampaignMap(); // 初始化campaignMap
        this.insertPrivacy(); // 插入隐私政策弹窗
        this.handleFcb();//  插入广告标识
        this.getStar();//获取星星评级
        this.insertCta();// 插入cta文字
        if (this.campaignInfo.title) {
            this.insertTitle();// 插入title
        }
        if (this.campaignInfo.image_url) {
            this.checkScreenOrientation();  //检查当前屏幕方向
        } else {    //否则显示无图片样式
            document.getElementById('container').classList.add('no-image');
        }
        if (this.campaignInfo.icon_url) {
            this.insertIcon(true);// 插入icon
        } else {
            let infoIcon = Array.from(document.getElementsByClassName("infoIcon"));
            for (let i of Array.from(infoIcon)) {
                i.classList.add('hide');    //  如果icon url不存在增加hide class隐藏
                if (this.screenOrientation === 'landscape') {
                    document.getElementsByClassName('info-other-rate')[1].style.marginBottom = '31vh';
                }
            }
        }
        if (this.campaignInfo.desc) {
            this.insertDes();// 插入描述
        }
        if (this.campaignInfo.click_url) {
            this.insertJumpUrl(() => {
                page.click({
                    bridgeContext: this.bridgeContext,
                    campaignMap: this.campaignMap[this.campaignId],
                    template: 'endcard',
                    currentOrientation:this.returnOrientation(),
                    autoClick:false,
                    isFromMoreOffer:false,
                })
            });//插入点击跳转事件
        } else {    //否则显示无图片样式
            let btnDownloadArr = document.getElementsByClassName('btn-download')
            for(let i of btnDownloadArr){
                i.classList.add('hide');
            }
        }
        let fullScreenClick = new FullScreenClick();
        fullScreenClick.initFullScreenClick(() => {
            page.click({
                bridgeContext: this.bridgeContext,
                campaignMap: this.campaignMap[this.campaignId],
                template: 'endcard',
                currentOrientation:this.returnOrientation(),
                autoClick:false,
                isFromMoreOffer:false,
            })
        }); // 初始化全屏可点
    }

    // 获取campaignIdList
    getCampaignIdList() {
        this.campaignIdList = this.campaignList.map(function (item) {
            return item.id
        })
        this.campaignId = this.campaignIdList[0];
    }

    bindCampaignId(){
        for (let i = 0; i < util.getEl('.jumpUrl').length; i++) {
            util.getEl('.jumpUrl')[i].setAttribute('campaignId', this.campaignId);
        }
    }
    //  返回屏幕方向
    returnOrientation(){
        if(this.screenOrientation === 'portrait'){
            return 1
        }else{
            return 2
        }
    }

    //  检查屏幕方向
    checkScreenOrientation() {
        if (this.supportOrientation) {
            if (window.orientation === 0) {
                this.screenOrientation = 'portrait';
            }
            if (window.orientation === 90 || window.orientation === -90) {
                this.screenOrientation = 'landscape';
            }
        } else {
            this.screenOrientation = (window.innerWidth > window.innerHeight) ? 'landscape' : 'portrait';
        }
        if (this.campaignInfo.image_url) {
            if (this.insertImageCount < 2) {
                this.insertImageCount++;
                this.getImgNaturalDimensions(this.campaignInfo.image_url)
            }
        } else {
            document.getElementById('container').classList.add('no-image');
        }
        if (this.orientationFlag) { //  在为true的时候交换屏幕长宽
            let temp = this.bodyWidth;
            this.bodyWidth = this.bodyHeight;
            this.bodyHeight = temp;
        } else {
            this.orientationFlag = true;
        }
    }

    //  获取图片宽高
    getImgNaturalDimensions(imgUrl) {
        let _this = this;
        let image = new Image()
        if (typeof imgUrl === 'string') {
            image.src = imgUrl;
        } else {
            image.src = imgUrl[0];
        }
        image.onload = () => {
            _this.imageWidth = image.width;
            _this.imageHeight = image.height;
            this.dynamicSetWidthAndHeight();  //    在获取到图片宽高之后调用设置宽高方法
        }
    }

    //  动态设置图片宽高
    dynamicSetWidthAndHeight() {
        if (this.screenOrientation === 'portrait') { // 竖屏
            this.portraitSwiperSet();
        } else if (this.screenOrientation === 'landscape') { //  横屏
            this.landscapeSwiperSet();
        }
    }

    //  插入图片
    insertImage(imgProps, sliderProps, swiperWrapperProps, centerStatus, fragment) {
        let swiperWrapper = document.createElement("div");//   创建swiperwrapper元素
        swiperWrapper.className = 'swiper-wrapper';
        if (centerStatus) { //  为true时给swiperWrapper增加居中属性
            //justify-content: center; 加这个属性之后当设置slidesPerView为auto，centeredSlides为true的时候可以保证【单个竖图】为居中显示
            //'-webkit-justify-content': 'center' 兼容ios8以下系统
            for (let p in swiperWrapperProps) {
                swiperWrapper.style.cssText += `${p}:${swiperWrapperProps[p]};`;
            }
        }
        //  当前图片字段返回数组，且数量大于1，多张图片的情况，目前接口没有返回多张的情况，后续加...
        if (Array.isArray(this.imageUrl) && this.imageUrl.length > 0) {
            for (let img of this.imageUrl) {
                let swiperSliderElem = document.createElement("div");
                swiperSliderElem.className = "swiper-slide";
                for (let p in imgProps) {
                    swiperSliderElem.style.cssText += `${p}:${imgProps[p]};`;
                }
                let swiperImg = new Image();
                swiperImg.src = img;
                swiperImg.className = 'jumpUrl';
                for (let p in imgProps) {
                    swiperImg.style.cssText += `${p}:${imgProps[p]};`;
                }
                swiperSliderElem.appendChild(swiperImg)
                swiperWrapper.appendChild(swiperSliderElem);
            }
            fragment.appendChild(swiperWrapper);
        }
        //  当前字段为字符串，则只有单张的情况
        if (typeof this.imageUrl === 'string' && this.imageUrl) {
            let swiperSliderElem = document.createElement("div");
            swiperSliderElem.className = "swiper-slide";
            for (let p in sliderProps) {
                swiperSliderElem.style.cssText += `${p}:${sliderProps[p]};`;
            }
            let swiperImg = new Image();
            swiperImg.src = this.imageUrl;
            swiperImg.className = 'jumpUrl';
            for (let p in imgProps) {
                swiperImg.style.cssText += `${p}:${imgProps[p]};`;
            }
            swiperSliderElem.appendChild(swiperImg)
            swiperWrapper.appendChild(swiperSliderElem);
            fragment.appendChild(swiperWrapper);
        }
    }

    //  设置竖屏下轮播图宽高比例
    setPortraitSliderProps(w, centerStatus = false) {
        const imageBox = document.getElementById('imageBox');
        const imageBoxWidth = this.imageBoxPortPer * this.bodyWidth;//  imagebox的宽度
        const currentImageWidth = imageBoxWidth * 0.92 * (w / 100)// 按传入的宽度显示，当前图片的宽度
        const currentImageHeight = currentImageWidth * (this.imageHeight / this.imageWidth);// 按传入的宽度显示，当前图片的高度
        const currentImageHeightPercent = currentImageHeight / this.bodyHeight;// 当前图片的高度所占的百分比比例，小数
        const imagePercent = this.imageHeight / this.imageWidth;//  图片实际比例
        const screenRatio = this.bodyHeight / this.bodyWidth;// 屏幕高度与宽度的比例
        let swiperContainer = document.getElementById('swiper-container-portrait');
        let imageBoxMaxHeightPercent = 0.43;
        if (screenRatio < 1.7) {
            imageBoxMaxHeightPercent = 0.39
        } else if (screenRatio >= 1.7 && screenRatio < 2) {
            imageBoxMaxHeightPercent = 0.45
        } else if (screenRatio > 2) {
            imageBoxMaxHeightPercent = 0.49
        }
        if (currentImageHeightPercent > imageBoxMaxHeightPercent) {
            imageBox.style.paddingTop = imageBoxMaxHeightPercent * 100 + 'vh';
            const fitHeightImageWidth = (imageBoxMaxHeightPercent * 100 / imagePercent) + 'vh';// 高度按最高高度显示后图片的宽度
            this.insertImage({}, {width: fitHeightImageWidth}, {'justify-content': 'center','-webkit-justify-content': 'center'}, centerStatus, this.fragmentPortrait);
        } else {
            this.insertImage({
                width: 'auto',
                height: '100%'
            }, {width: w + '%'}, {'justify-content': 'center','-webkit-justify-content': 'center'}, centerStatus, this.fragmentPortrait);
            //  当前图片的宽度 = 页面宽度即最外层盒子宽度*92%（减掉了两边的padding后）*当前图片设定的百分比
            //  （图片原始高/图片原始宽）*（图片当前宽/页面宽）*100%=当前盒子padding-top的百分比
            imageBox.style.paddingTop = `${(imagePercent) * (currentImageWidth / imageBoxWidth) * 100}%`;
        }
        //图片插入到html片段之后最终插入swiperContainer
        swiperContainer.innerHTML = null;
        swiperContainer.appendChild(this.fragmentPortrait);
    }

    //  设置横屏下轮播图宽高比例
    setLandscapeSliderProps(w, centerStatus = false) {
        const _this= this;
        const imageBox = document.getElementById('imageBoxLand');
        const imageBoxWidth = this.bodyWidth * this.imageBoxLandPer;//  imagebox的宽度
        //  当前图片的宽度 = 左侧页面宽度即最外层盒子宽度*当前图片设定的百分比
        const currentImageWidth = imageBoxWidth * 0.93 * (w / 100)// 按传入的宽度显示，当前图片的宽度
        const currentImageHeight = currentImageWidth * (this.imageHeight / this.imageWidth);// 按传入的宽度显示，当前图片的高度
        const currentImageHeightPercent = currentImageHeight / this.bodyHeight;// 当前图片的高度所占的百分比比例，小数
        const topAndBottomPadding = 0.04 * this.bodyHeight * 2;// 当前图片上下padding高度
        const imagePercent = this.imageHeight / this.imageWidth;//  图片实际比例
        const imageBoxMaxHeightPercent = (this.bodyHeight - topAndBottomPadding) / this.bodyHeight;//限制高度
        const imageBoxMaxHeight = this.bodyHeight - topAndBottomPadding;//限制高度
        const swiperContainer = document.getElementById('swiper-container-landscape');
        if (currentImageHeightPercent > imageBoxMaxHeightPercent) {
            console.log("高度大于最大高度");
            imageBox.style.paddingTop = imageBoxMaxHeightPercent * 100 + 'vh';
            const fitHeightImageWidth = (imageBoxMaxHeight / imagePercent) + 'px';// 高度按最高高度显示后图片的宽度
            console.log(this.bodyHeight)
            this.insertImage({
                width: 'auto',
                height: '100%'
            }, {width: fitHeightImageWidth}, {'align-items': 'center','-webkit-align-items': 'center'}, centerStatus, this.fragmentLandscape);
        } else {
            this.insertImage({
                width: '',
                height: ''
            }, {width: w + '%'}, {'align-items': 'center','-webkit-align-items': 'center'}, centerStatus, this.fragmentLandscape);
            //  （图片原始高/图片原始宽）*（图片当前宽/页面宽）*100%=当前盒子padding-top的百分比
            imageBox.style.paddingTop = `${(imagePercent) * (currentImageWidth / imageBoxWidth) * 100}%`;
        }
        swiperContainer.innerHTML = null;
        swiperContainer.appendChild(this.fragmentLandscape);
    }

    //  初始化竖屏轮播图
    initSwiperPortrait(swiperOptions) {
        //初始化轮播
        const mySwiper = new Swiper('.swiper-container-portrait', swiperOptions)
    }

    //  初始化横屏轮播图
    initSwiperLandscape(swiperOptions) {
        //初始化轮播
        const mySwiper = new Swiper('.swiper-container-landscape', swiperOptions)
    }

    //  竖屏轮播图设置
    portraitSwiperSet() {
        let swiperOptions = {}
        swiperOptions.direction = 'horizontal';
        if (typeof this.imageUrl === 'string') {
            let options = {
                allowTouchMove: false,
            }
            swiperOptions = Object.assign(swiperOptions, options)
            this.initSwiperPortrait(swiperOptions);
            this.setPortraitSliderProps('100', true)
        } else if (Array.isArray(this.imageUrl)) {
            if (this.imageUrl.length === 1) {
                let options = {
                    allowTouchMove: false,
                }
                swiperOptions = Object.assign(swiperOptions, options)
                this.initSwiperPortrait(swiperOptions)
                this.setPortraitSliderProps('100')
            } else if (this.imageUrl.length > 1) {
                let options = {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 15
                }
                swiperOptions = Object.assign(swiperOptions, options)
                this.initSwiperPortrait(swiperOptions)
                this.setPortraitSliderProps('86')
            }
        }
    }

    //  横屏轮播图设置
    landscapeSwiperSet() {
        let swiperOptions = {}
        swiperOptions.direction = 'vertical';
        if (typeof this.imageUrl === 'string') {
            let options = {
                allowTouchMove: false,
                centeredSlides: true,
            }
            swiperOptions = Object.assign(swiperOptions, options)
            this.initSwiperLandscape(swiperOptions)
            this.setLandscapeSliderProps('100', true)
        } else if (Array.isArray(this.imageUrl)) {
            if (this.imageUrl.length === 1) {
                let options = {
                    allowTouchMove: false,
                    centeredSlides: true,
                }
                swiperOptions = Object.assign(swiperOptions, options)
                this.initSwiperLandscape(swiperOptions)
                this.setLandscapeSliderProps('100')
            } else if (this.imageUrl.length > 1) {
                let options = {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 15
                }
                swiperOptions = Object.assign(swiperOptions, options)
                this.initSwiperLandscape(swiperOptions)
                this.setLandscapeSliderProps('86')
            }
        }
    }
}
// console.log("onload之前")
// window.onload = function(){
    // console.log("onload執行")
    // ios 8以下直接写在webview中执行init不生效
    // const renderDom = new Main();
    // renderDom.init();//本地测试用，并打开注释的三个campaign字段，注释掉eventInit()
    // renderDom.eventInit();//请求sdk接口获取campaign数据
// }
// 请求sdk接口获取campaign数据
page.getRewardJSContext({
    succ: function (res) {
        if (location.protocol === 'https:') {
            util.http2https(res);
        }
        let renderDom = new Main(res);
        renderDom.init();   // 插入数据内容
        renderDom.getCampaignIdList();
        page.webviewshow(function(){
            console.log("webviewshow")
            //小米4下必须在webviewshow之后执行
            window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", renderDom.checkScreenOrientation, false);

            page.initEndcardCloseBtn(res);// 初始化关闭按钮
            // iOS 下用户滑动时阻止页面回弹
            if (util.device().isiOS) {
                console.log("ios设备")
                let autoClick = new AutoClick({
                    linkType:res.campaignList[0].link_type,
                })
                console.log("准备执行自动storekit跳转")
                autoClick.initAutoClick(function () {
                    page.click({
                        bridgeContext: res,
                        campaignMap: res.campaignList[0],
                        template: 'endcard',
                        autoClick:true,
                        isFromMoreOffer:false,
                        currentOrientation:renderDom.returnOrientation
                    })
                });
            }
        })
    }
})
